const COMPANY_PRODUCT_SEARCH = {
    FILTER_OPENED: {
        event: 'companies_products_services_filter_opened',
        eventProperties: {
            description:
                'Triggered when an eligible user clicks the "+ Add" option for the PRODUCTS AND SERVICES filter on the Companies List page.',
        },
    },
    SEARCH_USED: {
        event: 'companies_products_services_search_used',
        eventProperties: {
            description:
                'Triggered when the user submits a search query in the modal search field for Products and Services.',
            search_term_length: 0,
        },
    },
    SKU_SELECTED: {
        event: 'companies_products_services_sku_selected',
        eventProperties: {
            description:
                'Triggered when the user selects one or more SKU checkboxes within the PRODUCTS AND SERVICES modal.',
            selected_sku_count: 0,
        },
    },
    FILTER_APPLIED: {
        event: 'companies_products_services_filter_applied',
        eventProperties: {
            description:
                'Triggered when the user clicks the Filter button in the modal and the Companies List page refreshes with the selected SKU filter applied.',
            selected_sku_count: 0,
            results_count: 0,
        },
    },
    FILTER_CANCELLED: {
        event: 'companies_products_services_filter_cancelled',
        eventProperties: {
            description:
                'Triggered when the user clicks Cancel in the modal and exits without applying the filter.',
            selected_sku_count: 0,
        },
    },
    MODAL_ABANDONED: {
        event: 'companies_products_services_modal_abandoned',
        eventProperties: {
            description:
                'Triggered when the modal is closed without the filter being applied, including close icon, click-away, or escape actions.',
            selected_sku_count: 0,
            had_search_activity: false,
        },
    },
    PAGE_VIEWED: {
        event: 'companies_page_viewed',
        eventProperties: {
            description:
                'Triggered when a user views the Companies List page. Used to establish the eligible audience denominator.',
        },
    },
};

export default COMPANY_PRODUCT_SEARCH;
